// Module
var code = "<div class=\"youtube\"> <iframe :width=\"width\" :height=\"height\" frameborder=\"0\" v-bind:src=\"`https://www.youtube-nocookie.com/embed/${videoId}`\" allow=\"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen></iframe> </div> ";
// Exports
module.exports = code;